// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7505cde9","453":"97eb43c0","455":"c540e980","977":"ddce96dc"}[chunkId] + ".chunk.js";
};